import { render, staticRenderFns } from "./LiftsGlobalDashboard.vue?vue&type=template&id=86717374&scoped=true"
import script from "./LiftsGlobalDashboard.vue?vue&type=script&lang=js"
export * from "./LiftsGlobalDashboard.vue?vue&type=script&lang=js"
import style0 from "./LiftsGlobalDashboard.vue?vue&type=style&index=0&id=86717374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86717374",
  null
  
)

export default component.exports